import React, { useState } from 'react'

import CustomCheckOrRadio from './../../../widgets/custom_check'

const initialStates = {
  recurring_cheked: true
}

const ProductIsRecurringCheckbox = ({ disabled = false, onStateChange }) => {

  const [state, setState] = useState(initialStates)

  const onValueChange = () => {
    setState((prevState) => ({
      ...prevState,
      recurring_cheked: !prevState.recurring_cheked
    }))

    onStateChange('recurring', !state.recurring_cheked)
  }

  return (
    <div className="product-is-recurring-check">
      <CustomCheckOrRadio
        type="checkbox"
        checked={state.recurring_cheked}
        onValueChange={onValueChange}
        disabled={disabled}
      />
      <span>Recurring</span>
    </div>
  )
}

export default ProductIsRecurringCheckbox